import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App';
import Menu from './containers/Menu';
import Page from './containers/Page';
import Post from './containers/Post';
import * as serviceWorker from './serviceWorker';

import 'tachyons';
//import { createLogger } from 'redux-logger';
//import { createStore, applyMiddleware, combineReducers } from 'redux';
import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { parseExportFile, updateSelection } from './reducers';

import { Route, BrowserRouter as Router} from 'react-router-dom';

const routing = (
	<Router>
		<Route exact path="/wp-export-file-parser" component={App} />
		<Route exact path="/wp-export-file-parser/menu" component={Menu} />
		<Route exact path="/wp-export-file-parser/pages" component={Page} />
		<Route exact path="/wp-export-file-parser/posts" component={Post} />
	</Router>
	)

//const logger = createLogger();
const rootReducer = combineReducers({ parseExportFile, updateSelection })
//const store = createStore(rootReducer, applyMiddleware(logger));
const store = createStore(rootReducer);

ReactDOM.render(
	<Provider store={store}>
		{ routing }
		<div className='fixed bottom-1 right-0 pa2 pl3 bg-light-gray gray f7 f6-ns'>powered by caskiSPACE</div>
	</Provider>, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
